module.exports = __webpack_public_path__ + "img/answer-right.d5bd1bd4.png";